import type { CustomFieldGroup } from "@web-app/types";

interface Fields {
  groupId: string;
  name?: string;
}

export const mapCustomFieldsGroupData = <T extends Fields>(
  fieldGroups: CustomFieldGroup[],
  fields: T[],
  searchText = "",
) => {
  const fieldsMap = new Map<
    string,
    {
      fields: T[];
      name: string;
    }
  >();

  fieldGroups.map((group) => {
    if (!fieldsMap.get(group.id)) {
      fieldsMap.set(group.id, {
        fields: [],
        name: group.name,
      });
    }

    fields.map((field) => {
      if (searchText) {
        const searchValue = searchText.toLowerCase();

        if (field.name && !field.name.toLowerCase().includes(searchValue)) {
          return;
        }
      }

      if (field.groupId === group.id) {
        fieldsMap.set(group.id, {
          fields: [...fieldsMap.get(group.id)!.fields, field],
          name: group.name,
        });
      }
    });
  });

  // Sort fields within each group
  fieldsMap.forEach((group) => {
    group.fields.sort((a, b) => {
      // First sort by active status (active fields first)
      if ("isActive" in a && "isActive" in b) {
        if (a.isActive !== b.isActive) {
          return a.isActive ? -1 : 1;
        }
      }
      // Then sort alphabetically by name
      return (a.name || "").localeCompare(b.name || "");
    });
  });

  return fieldsMap;
};
